// The audience part of message_user. It holds only an id, of a draft that
// propose_audience_edits stored or of a saved audience, which the chat reads
// with the member's own permissions, so it needs no worker check.

import { z } from "zod/v4";

/** The message_user part type of an audience card. */
export const AUDIENCE_PART_TYPE = "audience";

const audienceIdSchema = z.number().int().positive();

export const audiencePartSchema = z.union([
  // A proposal. The draft's audience_id tells creating (null) from editing (set).
  z.strictObject({
    draftId: z
      .uuid()
      .describe("The draftId that propose_audience_edits returned."),
  }),
  // A saved audience that the agent mentions without changing it.
  z.strictObject({
    audienceId: audienceIdSchema.describe("The id of a saved audience."),
  }),
]);

// A card for a saved audience that a Harness V2 agent mentions with message_user.
// It carries only the id, and the card reads the audience with the member's permissions.
export const AudienceReferenceResponseSchema = z.object({
  type: z.literal("audience_reference"),
  content: z.object({ existingId: audienceIdSchema }),
});

/** The draft or the saved audience that an audience part shows. */
export type AudiencePartTarget = z.infer<typeof audiencePartSchema>;

/** Returns the draft or saved audience of an audience part's data, or undefined for other data. */
export function audiencePartTarget(
  data: unknown,
): AudiencePartTarget | undefined {
  const parsed = audiencePartSchema.safeParse(data);
  return parsed.success ? parsed.data : undefined;
}
